import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@connect-x-app/hybrid-ui';
import { Channel, FlightRoomUserStatus } from '@connect-x-app/shared-domain-models';

import { CrewMemberInfoItem } from '../crewMemberInfoItem';

type Props = {
  channel: Channel;
  showOfflineText?: boolean;
};

export const UserInfoList = ({ channel, showOfflineText }: Props) => {
  const { t } = useTranslation();

  const activeUsers = useMemo(() => {
    return channel.users.filter(({ status }) => status !== FlightRoomUserStatus.PENDING);
  }, [channel]);

  return (
    <>
      {showOfflineText ? (
        <Text>{t('OFFLINE.USERS')}</Text>
      ) : (
        activeUsers.map(crewMember => <CrewMemberInfoItem crewMember={crewMember} key={crewMember.externalId} />)
      )}
    </>
  );
};
